import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { ChevronRight } from "lucide-react";

/**
 * DS ErrorBanner — figma 357:10162 "Frame 103" (에디터 상단 에러 summary banner).
 *
 * bg: Red/5 (#FCE9E9), padding 40×12, gap 8 column.
 * 상단: 16×16 icon (System/Error 색) + "아직 입력하지 않은 필수 항목이 있습니다." (Regular 14/22 System/Error)
 * 리스트: 각 항목 = 4×4 ellipse bullet (System/Error) + "탭이름 > 필드이름" path
 *   - path text: Regular 12/18 Text/Secondary
 *   - chevron: 12×12 Text/Tertiary (path 사이)
 *
 * 클릭 시 해당 필드로 스크롤 + 탭 전환 (onErrorClick 콜백).
 *
 * @param {object} props
 * @param {string} [props.title="아직 입력하지 않은 필수 항목이 있습니다."]
 * @param {Array<{id: string, segments: string[]}>} props.errors - 에러 항목 리스트
 * @param {(id: string) => void} [props.onErrorClick] - 에러 항목 클릭 콜백 (id 기준)
 */
const DSErrorBanner = ({
  title = "아직 입력하지 않은 필수 항목이 있습니다.",
  errors = [],
  onErrorClick,
}) => {
  if (!errors.length) return null;
  return (
    <div className="ds-error-banner" role="alert">
      <div className="ds-error-banner__header">
        <FontAwesomeIcon
          icon={faCircleExclamation}
          className="ds-error-banner__icon"
        />
        <span className="ds-error-banner__title">{title}</span>
      </div>
      <ul className="ds-error-banner__list">
        {errors.map((err) => (
          <li
            key={err.id}
            className="ds-error-banner__item"
            onClick={() => onErrorClick && onErrorClick(err.id)}
            role={onErrorClick ? "button" : undefined}
            tabIndex={onErrorClick ? 0 : undefined}
          >
            <span className="ds-error-banner__bullet" aria-hidden />
            <span className="ds-error-banner__path">
              {err.segments.map((seg, idx) => (
                <React.Fragment key={`${seg}-${idx}`}>
                  {idx > 0 && (
                    <ChevronRight size={12} className="ds-error-banner__chevron" />
                  )}
                  <span className="ds-error-banner__segment">{seg}</span>
                </React.Fragment>
              ))}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default React.memo(DSErrorBanner);
